module.exports = __webpack_public_path__ + "img/icons8-cardboard-box-128.7e80976b.png";